import { NgModule } from '@angular/core';

/** TRANSLATABLE STRINGS */
import { I18nStringsComponent } from './strings/i18n-strings.component';
import { I18nApiStringsComponent } from './strings/i18n-api-strings.component';

/** PIPES */
import { I18nStringPipe } from './pipes';

const components = [I18nStringsComponent, I18nApiStringsComponent, I18nStringPipe];

@NgModule({
	declarations: [...components],
	exports: [...components],
	imports: []
})
export class I18nModule {}
